import { EnvironmentProviders, InjectionToken, makeEnvironmentProviders } from '@angular/core';
import { GridLegacyAdapterConfig } from '../models';

export const GRID_LEGACY_ADAPTER_CONFIG = new InjectionToken<GridLegacyAdapterConfig>('GRID_LEGACY_ADAPTER_CONFIG');

/**
 * Configures host-side legacy adapter behavior
 */
export function provideGridLegacyAdapterConfig(config: GridLegacyAdapterConfig): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: GRID_LEGACY_ADAPTER_CONFIG,
      useValue: config,
    },
  ]);
}
